import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import classnames from 'classnames'
import TasksContainer from '@app/containers/students/Tasks'
import AnswerPresenter from '@app/components/Player/AnswerPresenter'
import BackLink from '@app/components/ui/buttons/BackLink'
import { totalScore } from '@app/helpers/studentsHelper'
import { Score } from '@app/constants'
import Api from '@app/api'

const answerContext = (answer) => {
  if (!answer || answer.score === Score.min) {
    return ['student-answer-page__points--wrong', I18n.t('main_results.task.solved_incorrectly')]
  }
  else if (answer.score === Score.max) {
    return ['student-answer-page__points--true', I18n.t('main_results.task.solved_correctly')]
  }
  else {
    return ['student-answer-page__points--partially', I18n.t('main_results.task.solved_partially')]
  }
}

const Answer = ({ answer }) => {
  let [classname, content] = answerContext(answer);

  return (
    <div className="student-answer-page__points-description">
      { content }
    </div>
  )
}

const MyAnswer = ({ id }) => {
  return (
    <Fragment>
      <h5 className="f--bold m-1">
        { I18n.t('cards.your_answer') }
      </h5>
      <AnswerPresenter
        className="mb-2 m-1"
        url={Api.students.answer({ tour: 'main', id }).routes.resourcesURL}
      />
    </Fragment>
  )
}

const CorrectAnswer = ({ id }) => {
  return (
    <Fragment>
      <h5 className="f--bold m-1">
        { I18n.t('main_results.right_answer') }
      </h5>
      <AnswerPresenter
        className="mb-2 m-1"
        url={Api.students.answer({ tour: 'main', id }).correct.path}
      />
    </Fragment>
  )
}

const Content = (props) => {
  const { statistics, route: { match: { params: { id } } } } = props
  const objects = _.values(statistics.objects)
  const { task, answer } = statistics.objects[id]
  let [classname, content] = answerContext(answer);

  return (
    <div className="student-answer-page">
      <div className="student-answer-page__header">
        <BackLink to='/students/results/tasks' className="h-flex-layout mb-0">
          TO TASK LIST
        </BackLink>
      </div>
      <div className="student-answer-page__task-explanation">
        <div className="student-answer-page__task-name">
          {task.name}
        </div>
        <div className="student-answer-page__points-wrapper">
          <div className={classnames('student-answer-page__points', classname)}>
            {answer?.score || 0} of 10 points
          </div>
          <Answer answer={answer}/>
        </div>
      </div>
      <div className="answer">
        <div className="answer__inner">
          {
            answer ? (<MyAnswer id={id}/>) : null
          }

          {
            !answer || answer.score !== Score.max ? (
              <CorrectAnswer id={id}/>
            ) : null
          }
        </div>
      </div>
    </div>
  )
}

const Solution = (props) => {
  return (
    <TasksContainer {...props} tour="main" ChildComponent={Content} />
  )
}

export default Solution
